<cu-dynamic-page-workflow-progress class="ww-position--sticky" [page]="page" [flow]="flow"></cu-dynamic-page-workflow-progress>
<cu-dynamic-page-layout [page]="page" [flow]="flow">
  <div page-body>
    <cu-dynamic-page-header [page]="page" [flow]="flow"></cu-dynamic-page-header>
    <cu-dynamic-page-alert [page]="page" [flow]="flow"></cu-dynamic-page-alert>
    <cu-dynamic-page-validation [page]="page" [flow]="flow"></cu-dynamic-page-validation>
    <section *ngIf="!page.actionButtonIsLoading; else loader">
      <cu-dynamic-page-cards [page]="page" [flow]="flow"></cu-dynamic-page-cards>
    </section>
    <cu-dynamic-page-action-bar [page]="page" [flow]="flow"></cu-dynamic-page-action-bar>
    <cu-dynamic-page-modal-popup *ngIf="page.modalVisible" [page]="page" [flow]="flow"></cu-dynamic-page-modal-popup>
  </div>
</cu-dynamic-page-layout>


<ng-template #loader>
  <div class="dx-workflow-card bl-block-module">
    <ea-orbit-loader [loading]="true"></ea-orbit-loader>
    <p class="bl-text-align--center bl-text-style--display-6">
      {{ 'standardPage/waitingMessage' | dictionary }}
    </p>
  </div>
</ng-template>
@if(flow?.loader){
<div class="bl-top--0 dx-workflow-loader bl-position--fixed bl-width--100 bl-height--100 bl-bg-color--snow">
  <ea-orbit-loader [loading]="true"></ea-orbit-loader>
</div>
}
